import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from 'recharts';
import { Inbox } from 'lucide-react';
import { Panel, Metric, Empty } from './Panel';
import { fmtMonYY } from '../../../lib/date';

export const InquiryCard = ({ q }) => {
  const data = q.trend.map((t) => ({ ...t, label: fmtMonYY(t.month) }));
  const top = Math.max(1, ...q.top_sources.map((s) => s.count));
  return (
    <Panel title="Inquiry & referral trends" subtitle="Last 6 months" icon={Inbox} to="/inquiries" linkLabel="Open inquiries" testid="ludo-dash-inquiries">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
        <Metric label="This month" value={q.this_month} sub={`Last month ${q.last_month}`} testid="ludo-dash-inq-month" />
        <Metric label="Awaiting contact" value={q.open_new} tone={q.open_new ? 'text-[#8A3A3A]' : undefined} testid="ludo-dash-inq-new" />
        <Metric label="Follow-up" value={q.contacted} testid="ludo-dash-inq-contacted" />
        <Metric label="Referral links" value={q.active_links} testid="ludo-dash-inq-links" />
      </div>
      <div className="grid lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3 h-56" data-testid="ludo-dash-inq-chart">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#F1EDF5" vertical={false} />
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#8A7B95' }} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#8A7B95' }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ borderRadius: 12, border: '1px solid #d6e0de', fontSize: 12 }} cursor={{ fill: '#ede9f4' }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Bar dataKey="inquiries" name="Inquiries" fill="#839e97" radius={[6, 6, 0, 0]} />
              <Bar dataKey="new_clients" name="New clients" fill="#baa9ca" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="lg:col-span-2" data-testid="ludo-dash-sources">
          <div className="text-[11px] uppercase tracking-[0.12em] text-[#8A7B95] font-semibold mb-2">Top referral sources</div>
          {q.top_sources.length === 0 ? <Empty>No referral sources recorded yet.</Empty> : q.top_sources.map((s) => (
            <div key={s.source} className="mb-2" data-testid={`ludo-dash-source-${s.source.replace(/\W+/g, '-').toLowerCase()}`}>
              <div className="flex justify-between text-[12.5px]"><span className="text-[#2D2833] truncate">{s.source}</span><span className="tabular-nums font-semibold">{s.count}</span></div>
              <div className="h-1.5 rounded-full bg-[#F1EDF5] mt-1"><div className="h-full rounded-full bg-[#A99BB8]" style={{ width: `${(100 * s.count) / top}%` }} /></div>
            </div>
          ))}
          {q.top_links.length > 0 && (
            <div className="mt-4 text-[12px] text-[#6E5F78]" data-testid="ludo-dash-top-links">
              <div className="text-[11px] uppercase tracking-[0.12em] text-[#8A7B95] font-semibold mb-1">Top referral partners</div>
              {q.top_links.map((l, i) => <div key={i} className="flex justify-between"><span>{l.partner_name || l.category}</span><span className="tabular-nums">{l.submission_count || 0}</span></div>)}
            </div>
          )}
        </div>
      </div>
    </Panel>
  );
};

export default InquiryCard;
